import React from 'react'

const ErrorMessage = (props) =>
    <>
    {props?.err_msg1?.length >= 50 ?
      <span automationid="LoginPage_Span_ErrorMsg_4" className="sub-title">{props.err_msg1}<br /><br />
        {props.err_msg2}</span>
        :
        <span automationid="LoginPage_Span_ErrorMsg_4" className="sub-title">{props.err_msg1}<br />
        {props.err_msg2}</span>
    }
        </>
export default ErrorMessage; 